import { useState, useCallback, useEffect, useRef } from "react";

import {
  Box,
  Flex,
  Text,
  useDisclosure,
  Icon,
  Button,
  Checkbox,
  Progress,
} from "@chakra-ui/react";

import { TableRelatorioPendencia } from "../../components/TableRelatorioPendencia";
import LoadingSpinner from "../../components/LoadingSpinner";

import { useAuthProvider } from "../../../Context/AuthProvider";
import { useAppContext } from "../../../Context/MessageContextProvider";
import Group from "../ServicosAcolhimento/Visualizar/Group";

import { FiltersFilaProcessamento } from "../../components/FiltersFilaProcessamento";
import { ReactComponent as RelatorioFila } from "../../../assets/images/relatoriofila.svg";
import SemRegistros from "../../components/SemRegistros";
import { dashboardFunc } from "../../../helpers/Funcionalidades";
import Swal from "sweetalert2";
import RelatorioService from "../../../main/services/RelatorioService";

export const FilaProcessamento = () => {
  const [loading, setLoading] = useState(false);

  const { roleKeycloack, user } = useAuthProvider();
  const { idPJ } = useAppContext();

  const [selectedRows, setSelectedRows] = useState(() => {
    const saved = sessionStorage.getItem("selectedRows");
    return saved ? JSON.parse(saved) : [];
  });

  const handleSelectRow = (id) => {
    setSelectedRows((prev) => {
      const newSelection = prev.includes(id)
        ? prev.filter((rowId) => rowId !== id)
        : [...prev, id];
      sessionStorage.setItem("selectedRows", JSON.stringify(newSelection));
      return newSelection;
    });
  };

  const deleteFilaProcessamento = (idsFila) => {
    Swal.fire({
      title: "Atenção!",
      text: "Deseja realmente excluir os registros marcados?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#169499",
      cancelButtonColor: "#169499",
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((result) => {
      if (result.isConfirmed) {
        RelatorioService.deleteAllFilaProcessamento(idsFila)
          .then((res) => {
            Swal.fire({
              title: "Sucesso!",
              text: "Registro Excluído.",
              icon: "success",
              confirmButtonText: "Continuar",
              confirmButtonColor: "#169499",
            }).then((result) => {});
            setSelectedRows([]);

            sessionStorage.removeItem("selectedRows");
          })
          .catch((error) => {
            console.log(error?.response?.data);
            Swal.fire({
              title: "Atenção!",
              text: error.response.data.message
                ? error?.response?.data?.message
                : "",
              icon: "error",
              confirmButtonText: "Fechar",
              confirmButtonColor: "#169499",
            });
          })
          .finally(() => {
            setAtualizarDadosTabela(true);
          });
      }
    });
  };

  const verificarProcessamento = useCallback(async () => {
    const res = await RelatorioService.getFilaProcessamentoAtivos();

    if (res?.data) {
      Swal.fire({
        title: "",
        html: "<strong style='font-size: 22px;'>Relatório ainda em processamento.</strong>",
        icon: "success",
        width: "500px",
        showCancelButton: true,
        confirmButtonText: "Atualizar Novamente",
        confirmButtonColor: "#169499",
        cancelButtonColor: "#169499",
        cancelButtonText: "Fechar",
      }).then((result) => {
        if (result.isConfirmed) {
          setAtualizarDadosTabela(true);
          setAtualizarFilaProcessamento(true);
        }
      });
    }
  }, []);

  const {
    isOpen: isOpenNovoAcolhimento,
    onOpen: onOpenNovoAcolhimento,
    onClose: onCloseNovoAcolhimento,
  } = useDisclosure();
  const [atualizarDadosTabela, setAtualizarDadosTabela] = useState(false);
  const [atualizarFilaProcessamento, setAtualizarFilaProcessamento] =
    useState(false);

  const columns = [
    {
      Header: "Tipo Relatório",
      accessor: "nomeTipoRelatorio",
      Cell: (props) => {
        const idFila = props?.row?.original?.id;
        const status = props?.row?.original?.status;

        const showCheckbox = !status?.toLowerCase().startsWith("aguardando");

        return (
          <Flex gap={4}>
            {showCheckbox ? (
              <Checkbox
                isChecked={selectedRows?.includes(idFila)}
                onChange={() => handleSelectRow(idFila)}
                borderColor="#b3b3b3"
              />
            ) : (
              <Box width="14px" />
            )}
            <Flex alignItems={"center"} gap={2}>
              <Icon as={RelatorioFila} boxSize={6} color="black" />

              <span>{props.value}</span>
            </Flex>
          </Flex>
        );
      },
    },

    {
      Header: "Data da Solicitação",
      accessor: "dataHoraInicio",
      Cell: ({ value }) => {
        if (!value) return null;

        const date = new Date(value);

        const dia = String(date.getDate()).padStart(2, "0");
        const mes = String(date.getMonth() + 1).padStart(2, "0");
        const ano = date.getFullYear();

        const horas = String(date.getHours()).padStart(2, "0");
        const minutos = String(date.getMinutes()).padStart(2, "0");

        return <span>{`${dia}/${mes}/${ano} ${horas}h${minutos}`}</span>;
      },
    },
    {
      Header: "Status",
      accessor: "status",
      Cell: (props) => {
        const isAguardando = props.value
          ?.toLowerCase()
          .startsWith("aguardando");
        return (
          <Flex alignItems="center" gap={2}>
            <Text
              fontWeight={"bold"}
              color={
                props.value.includes("Concluído")
                  ? "#169499"
                  : props.value.includes("Aguardando")
                    ? "#B9690D"
                    : "#A73737"
              }
            >
              {props.value ?? ""}
            </Text>
            {isAguardando && (
              <Flex alignItems="center" gap={1}>
                <Progress
                  value={((5 - countdown) / 5) * 100}
                  colorScheme="orange"
                  size="xs"
                  borderRadius="md"
                  w="60px"
                />
                <Text fontSize="xs" color="#B9690D" whiteSpace="nowrap">
                  {countdown}s
                </Text>
              </Flex>
            )}
          </Flex>
        );
      },
    },
  ];

  const [data, setData] = useState();

  const intervalRef = useRef(null);
  const loadingRef = useRef(loading);
  const [countdown, setCountdown] = useState(5);

  const hasAguardando =
    data?.content?.some((item) =>
      item.status?.toLowerCase().startsWith("aguardando"),
    ) ?? false;

  useEffect(() => {
    loadingRef.current = loading;
  }, [loading]);

  useEffect(() => {
    if (!hasAguardando) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
      setCountdown(5);
      return;
    }

    setCountdown(5);
    intervalRef.current = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          if (!loadingRef.current) {
            setAtualizarDadosTabela(true);
          }
          return 5;
        }
        return prev - 1;
      });
    }, 1000);

    return () => {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    };
  }, [hasAguardando]);

  return roleKeycloack &&
    roleKeycloack?.includes(dashboardFunc.filaProcessamentoConsultar) ? (
    <Flex
      flex={1}
      flexDir="column"
      px={["5px", "32px"]}
      pb="20px"
      alignItems="center"
      overflow="auto"
    >
      <Group
        mt={1}
        title={"Fila de Processamento"}
        opcoes={true}
        voltar={true}
        dividerFalse={true}
      >
        <>
          <Box mt={4}>
            <FiltersFilaProcessamento
              data={data}
              setData={setData}
              setLoading={setLoading}
              loading={loading}
              entidade="fila-processamento"
              roleKeycloack={roleKeycloack}
              atualizarDadosTabela={atualizarDadosTabela}
              setAtualizarDadosTabela={setAtualizarDadosTabela}
              setSelectedRows={setSelectedRows}
              atualizarFilaProcessamento={atualizarFilaProcessamento}
              setAtualizarFilaProcessamento={setAtualizarFilaProcessamento}
              verificarProcessamento={verificarProcessamento}
            />
          </Box>

          {!loading ? (
            data && (
              <>
                <Flex pl={"21px"} justifyContent={"space-between"}>
                  <Flex gap={4}>
                    <Checkbox
                      isChecked={
                        data?.content
                          ?.filter(
                            (item) =>
                              !item.status
                                .toLowerCase()
                                .startsWith("aguardando"),
                          )
                          .every((item) => selectedRows.includes(item.id)) &&
                        data?.content?.filter(
                          (item) =>
                            !item.status.toLowerCase().startsWith("aguardando"),
                        ).length > 0
                      }
                      isIndeterminate={
                        selectedRows.some((id) =>
                          data?.content
                            ?.filter(
                              (item) =>
                                !item.status
                                  .toLowerCase()
                                  .startsWith("aguardando"),
                            )
                            .map((item) => item.id)
                            .includes(id),
                        ) &&
                        !data?.content
                          ?.filter(
                            (item) =>
                              !item.status
                                .toLowerCase()
                                .startsWith("aguardando"),
                          )
                          .every((item) => selectedRows.includes(item.id))
                      }
                      onChange={(e) => {
                        const selectableIds = data?.content
                          .filter(
                            (item) =>
                              !item.status
                                .toLowerCase()
                                .startsWith("aguardando"),
                          )
                          .map((item) => item.id);

                        if (e.target.checked) {
                          const newSelection = Array.from(
                            new Set([...selectedRows, ...selectableIds]),
                          );
                          setSelectedRows(newSelection);
                          sessionStorage.setItem(
                            "selectedRows",
                            JSON.stringify(newSelection),
                          );
                        } else {
                          const newSelection = selectedRows.filter(
                            (id) => !selectableIds.includes(id),
                          );
                          setSelectedRows(newSelection);
                          sessionStorage.setItem(
                            "selectedRows",
                            JSON.stringify(newSelection),
                          );
                        }
                      }}
                      borderColor="#b3b3b3"
                      color={"#169499"}
                      disabled={data.content && data.content.length <= 0}
                      fontWeight={900}
                    >
                      Selecionar Todos
                    </Checkbox>

                    <Button
                      px={2}
                      py={5}
                      color="#169499"
                      border="1px solid #169499"
                      backgroundColor="#EBF3F2"
                      fontWeight={1000}
                      fontSize="14px"
                      lineHeight="150%"
                      _hover={{ bg: "#DDEBEA" }}
                      disabled={!(selectedRows?.length > 0)}
                      onClick={() => deleteFilaProcessamento(selectedRows)}
                    >
                      Excluir Todos
                    </Button>
                  </Flex>
                  {/*  <Button
                    px={2}
                    py={5}
                    color="#169499"
                    border="1px solid #169499"
                    backgroundColor="#EBF3F2"
                    fontWeight={1000}
                    fontSize="14px"
                    lineHeight="150%"
                    _hover={{ bg: "#DDEBEA" }}
                    onClick={() => {
                      setAtualizarDadosTabela(true);
                      setAtualizarFilaProcessamento(true);
                    }}
                  >
                    Atualizar Processamento
                  </Button> */}
                </Flex>
                <TableRelatorioPendencia
                  data={data.content}
                  columns={columns}
                  selectedRows={selectedRows}
                  handleSelectRow={handleSelectRow}
                  setSelectedRows={setSelectedRows}
                  isOpenNovoAcolhimento={isOpenNovoAcolhimento}
                  onOpenNovoAcolhimento={onOpenNovoAcolhimento}
                  onCloseNovoAcolhimento={onCloseNovoAcolhimento}
                  entidade="fila-processamento"
                  atualizarDadosTabela={atualizarDadosTabela}
                  setAtualizarDadosTabela={setAtualizarDadosTabela}
                  roleKeycloack={roleKeycloack}
                  user={user}
                  setData={setData}
                  idPJ={idPJ}
                />
              </>
            )
          ) : (
            <Box mt={4}>
              <LoadingSpinner />
            </Box>
          )}
        </>
      </Group>
    </Flex>
  ) : (
    <Box mt={2}>
      <SemRegistros buttonVisible={true} half />
    </Box>
  );
};
